<template>
  <div class="overlay" v-if="asideopen" @click="asideopen = false"></div>
  <div>
    <div class="sub-nav py-3 flex items-center" style="position: fixed">
      <div class="sidebar-button flex items-center" @click="asideopen = true">
        <i class="el-icon mr-2" style="font-size: 20px"
          ><!--[--><svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="2" y="7" width="11" height="2" fill="#606266"></rect>
            <rect x="2" y="11" width="14" height="2" fill="#606266"></rect>
            <rect x="2" y="15" width="8" height="2" fill="#606266"></rect>
            <rect x="2" y="3" width="16" height="2" fill="#606266"></rect></svg
          ><!--]--></i
        >
      </div>
    </div>
  </div>
  <el-container class="main">
    <Header></Header>
    <el-container>
      <el-asider :class="{ open: asideopen, 'el-aside': true }">
        <Menu />
      </el-asider>
      <el-main style="min-width: var(--el-main-width)">
        <slot></slot>
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { ref } from "vue";
import Header from "@/components/header";
import Menu from "@/components/menu";
const asideopen = ref(false);
</script>

<style scoped>
:root {
  --el-menu-bg-color: #545c64;
  --overlay-z-index: 30;
}

.el-container {
  display: flex;
  flex-direction: row;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
}
.main {
  height: 100%;
}
.el-aside {
  width: 200px;
}

@media (max-width: 767px) {
  .el-aside {
    width: calc(var(--vp-sidebar-width-mobile) - 14px);
    transform: translate(-100%);
    position: fixed;
    height: 100%;
    background-color: var(--el-color-black);
    z-index: 999;
  }
}
@media screen and (min-width: 960px) {
  .sub-nav {
    display: none !important;
  }
}
.el-aside.open {
  transform: translate(0);
}
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(240, 238, 238, 0.6);
  transition: opacity 0.5s;
  z-index: 30;
}
</style>
